import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { getSocialLogin } from '../../refresh/selectors/featureFlagsSelector';
import SocialAccount from './SocialAccountComponent';

class SignInSocial extends React.Component {
  constructor(props) {
    super(props);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.state = {
      errorMsg: '',
      mobNum: ''
    };
  }

  handleSubmit(event) {
    event.preventDefault();
    window.location = '/login/otp';
  }

  render() {
    let otpMsg = 'OTP will be sent to your number for verification.';
    const { queryString = '', socialLoginEnabled = true } = this.props;
    return (
      <div>
        <form
          className="login-form"
          onSubmit={this.handleSubmit}
          data-ga-event-category=""
          data-ga-event-action=""
          data-ga-event-label=""
        >
          <h1> Glad you&#39;re back! </h1>

         {socialLoginEnabled && <SocialAccount queryString={queryString} /> }

          <div className="login-form-inputs forgot-text">Forgot your password?</div>

          <div>
            <input
              type="button"
              className={
                this.state.errorMsg == ''
                  ? 'login-form-inputs only-border-btn'
                  : 'login-form-inputs login-btn'
              }
              value="LOGIN WITH OTP"
              onClick={() => {
                this.generateOTP();
              }}
            />
          </div>

          <div className="login-form-inputs btn-action-txt otp-text">
            We will send an OTP to your registered mobile number and email id.
          </div>
        </form>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
    return {};
}

const mapStateToProps = (state, ownProps) => {
  const { flags = {} } = state;
  const socialLoginEnabled = getSocialLogin(flags);
  return{
    socialLoginEnabled: socialLoginEnabled
  };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SignInSocial));
